<mat-toolbar color="primary" class="top-nav">
  <span class="nav-brand">Fitzidx</span>
  <nav class="nav-links" aria-label="Primary">
    <a mat-button routerLink="/home" routerLinkActive="active">Home</a>
    <a mat-button routerLink="/products" routerLinkActive="active">Products</a>
    <a mat-button routerLink="/customers" routerLinkActive="active">Customers</a>
    <a mat-button routerLink="/vendors" routerLinkActive="active">Vendors</a>
    <a mat-button routerLink="/purchase-orders" routerLinkActive="active">Purchase Orders</a>
    <a mat-button routerLink="/orders" routerLinkActive="active">Sales Orders</a>
    <a mat-button routerLink="/sales-invoices" routerLinkActive="active">Sales Invoices</a>
    <a mat-button routerLink="/proformas" routerLinkActive="active">Proformas</a>

  </nav>
  <span class="spacer"></span>
  <app-search [appearance]="'nav'" class="nav-search"></app-search>
  <button mat-icon-button (click)="logout()" title="Logout" aria-label="Logout">
    <mat-icon>logout</mat-icon>
  </button>
</mat-toolbar>

<div class="page-content">
  <router-outlet />
</div>
